// Floating UI strategy shared by RfMenu and RfTooltip.

import { flip, offset, shift, size } from "@floating-ui/dom";

export const FLOATING_UI_DEFAULT_PLACEMENT = "bottom-start";
export const TOOLTIP_DEFAULT_PLACEMENT = "top";

// `size` middleware apply: clamp the floating element to the available viewport space.
const clampToViewport = ({ availableWidth, availableHeight, elements }) => {
  Object.assign(elements.floating.style, {
    maxWidth: `${availableWidth}px`,
    maxHeight: `${availableHeight - 16}px`,
  });
};

export const FLOATING_UI_MENU_PRESETS = {
  promptStatus: {
    placement: "bottom-start",
    middleware: [
      offset({ mainAxis: 6, crossAxis: -5 }),
      flip(),
      shift({ padding: 5 }),
      size({ apply: clampToViewport }),
    ],
  },
  promptMenu: {
    middleware: [
      offset({ mainAxis: 6 }),
      flip(),
      shift({ padding: 5 }),
      size({ apply: clampToViewport }),
    ],
  },
  promptMenuEnd: {
    placement: "bottom-end",
    middleware: [
      offset({ mainAxis: 6 }),
      flip(),
      shift({ padding: 5 }),
      size({ apply: clampToViewport }),
    ],
  },
  datePicker: {
    placement: "bottom-end",
    middleware: [offset({ mainAxis: 6 }), flip(), size({ apply: clampToViewport })],
  },
  appSelectorSmall: {
    placement: "bottom-end",
    middleware: [
      offset({ mainAxis: -10, crossAxis: 28 }),
      flip(),
      size({ apply: clampToViewport }),
    ],
  },
  default: {
    middleware: [offset({ mainAxis: 6 }), flip(), size({ apply: clampToViewport })],
  },
  // Menus inside dialogs/modals: always open downward and shrink to fit the
  // available space instead of flipping above the trigger — flip() flips up
  // whenever the natural menu height outgrows the space below.
  modalMenu: {
    placement: "bottom",
    middleware: [offset({ mainAxis: 6 }), shift({ padding: 5 }), size({ apply: clampToViewport })],
  },
};
